import styled from "styled-components";

export const FooterPlayerProgressAudio = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-3px);
  left: 0;
  height: 100%;
  max-height: 4px;
  background: ${({ typeStream }) => {
    switch (typeStream) {
      case "rock":
        return "#fff";
      case "mc":
        return " rgba(215, 62, 41, 1)";
      case "lite":
        return "rgba(115, 113, 255, 1)";
      default:
        return "var(--orange-primary)";
    }
  }};
  box-shadow: 0px 0px 7px 0px;
  color: ${({ typeStream }) => {
    switch (typeStream) {
      case "rock":
        return "rgba(255, 255, 255, 1)";
      case "mc":
        return " rgba(215, 62, 41, 1)";
      case "lite":
        return "rgba(120, 118, 240, 1)";
      default:
        return "rgba(255, 0, 123, 1)";
    }
  }};
`;

export const FooterPlayerLoadedAudio = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-3px);
  left: 0;
  height: 100%;
  max-height: 4px;
  background: var(--white-secondary);
`;

export const FooterPlayerThumb = styled.div`
  position: absolute;
  top: 50%;

  &::before {
    content: "";
    position: absolute;
    width: 14px;
    height: 14px;
    top: 0;
    left: 50%;
    background: var(--orange-primary);
    border-radius: 50%;
    transform: translate(-50%, -8px) scale(0);
    transition: transform 0.2s ease-in-out;
    cursor: pointer;
  }
`;

export const FooterPlayerAudioRange = styled.div`
  position: absolute;
  padding: 6px 0;
  top: -4px;
  width: 100%;
  height: 4px;
  user-select: none;
  cursor: ${({ isStream }) => (isStream ? "default" : "pointer")};

  &:hover ${FooterPlayerThumb} {
    &::before {
      transform: translate(-50%, -8px) scale(1);
    }
  }
`;
